<template>
	<div class="relative">
		<div class="bg-gray px-3 py-2 flex items-center">
			<span>
				<church-icon class="!w-4 !h-4 mr-2" icon="search"></church-icon>
			</span>
			<input type="text" v-model="searchString" placeholder="Search user" class="w-full bg-transparent">
		</div>

		<div v-if="filteredUsers.length > 0" class="bg-white absolute top-0 left-0 z-10 w-full mt-10 rounded-md p-4 shadow-lg space-y-4">
			<div v-for="user in filteredUsers || []" :key="user.ID" class="flex items" @click="() => (emit('selected', user), searchString = '')">
				<div class="mr-2">
					<church-icon v-if="!user?.avatar" class="!w-6 !h-6" icon="person-circle-fill"></church-icon>
					<img v-else class="w-6 h-6 object-fit rounded-full overflow-clip border border-white" :src="user?.avatar" alt="">
				</div>
				<div class="flex-1">
					{{UserUtils.getFullName(user) || ''}}
				</div>
				
			</div>
		</div>
	</div>
</template>

<script setup>
/* ======= UTILS ===== */
import UserUtils from '@/helpers/userUtils';
import { computed, defineProps, defineEmits, ref } from 'vue';

/* ========= PROPS ======= */
const props = defineProps({
	users : {type : Array, default : () => []}
})

/* =========== STATES ======== */
const searchString = ref('')

/* ========= EMITS ======== */
const emit = defineEmits(['selected'])

/* =========== COMPUTED ======== */
/**
 * Filtered user list
 */
const filteredUsers = computed(() => {
	if(searchString.value == '') return []
	return  props.users.filter(user => user.display_name.toLowerCase().includes(searchString.value.toLowerCase()))
})	


</script>
